var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._t("menu")],2)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }